/**
 * OrbDocTutorialsAdvancedFullAppAROrbDocTutorialsAdvancedFullAppARPage
 *
 * Page component for OrbDocTutorialsAdvancedFullAppAROrbDocTutorialsAdvancedFullAppARPage
 * Path: /ar/docs/tutorials/advanced/full-app
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsAdvancedFullAppARDocScreenView as __OrbDocTutorialsAdvancedFullAppARDocScreenView } from '@/components/traits/OrbDocTutorialsAdvancedFullAppARDocScreenView';
import { OrbDocTutorialsAdvancedFullAppARDocAnalyticsView as __OrbDocTutorialsAdvancedFullAppARDocAnalyticsView } from '@/components/traits/OrbDocTutorialsAdvancedFullAppARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsAdvancedFullAppAROrbDocTutorialsAdvancedFullAppARPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsAdvancedFullAppAROrbDocTutorialsAdvancedFullAppARPage(_props: OrbDocTutorialsAdvancedFullAppAROrbDocTutorialsAdvancedFullAppARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"ابنِ تطبيقًا كاملًا","description":"عدة مداريّات، وسلوكيات قياسية مركَّبة، وصفحات مترابطة، وأحداث تصل بينها.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/advanced/full-app"},{"locale":"ar","path":"/ar/docs/tutorials/advanced/full-app"},{"locale":"sl","path":"/sl/docs/tutorials/advanced/full-app"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsAdvancedFullAppARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsAdvancedFullAppARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsAdvancedFullAppAROrbDocTutorialsAdvancedFullAppARPage;
